<button (click)="openCreate()" class="btn btn-primary-outline add-button">Add</button>
<h5 class="mb-4">Employee Ranks</h5>

@if (employeeRanks().length > 0) {
  <app-sortable-table [headers]="headers" class="table-striped">
    @for (rank of employeeRanks(); track rank) {
      <tr>
        <td>{{ rank.rank | enumParse }}</td>
        <td>{{ rank.startDate | dateParse | dateFormat: 'ddd, D MMM YYYY' }}</td>
        @if (canEditAtDate(rank.startDate)) {
          <td>
            <i (click)="openUpdate(rank)" class="fa fa-xs fa-pen pointer me-1"></i>
            <i (click)="openDelete(rank)" class="fa fa-xs fa-trash pointer"></i>
          </td>
        } @else {
        <td></td>
      }
      </tr>
    }
  </app-sortable-table>
}